define([
    'text!index2021/component/image-slick.html',
    // 'common/api',
    'jquery',
    '../common/utils',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!index2021/component/image-slick.css'

], function(
    tpl,
    // Api,
    $,Utils,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {

            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwipersImages: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String
        },
        methods: {
            initss: function () {
                if(this.SwiperType=='buy'){
                    new Swiper('#swiper-buy',{
                        spaceBetween: 1000,
                        effect: 'fade',
                        observer: true,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        }
                    });
                }
            }
        },
        watch: {
            SwipersImages: function () {
                this.initss();
            }
        },
        mounted: function(){
            // this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021/component/image-slick.js
// module id = 127
// module chunks = 1 9